module.exports = __webpack_public_path__ + "static/media/banner_3.ed742073.png";